// --------------------------------------------------
//   Imports
// --------------------------------------------------


// React
import React, {useState, useEffect} from "react";
import { useParams, useLocation } from 'react-router-dom';

// Material UI
import {
    Paper,
    TableContainer,
    Typography,
    Box,
    Link,
} from '@mui/material';

// Custom Components
import StudentActivityTable from "./tables/StudentActivityTable";



// --------------------------------------------------
//   Main Component
// --------------------------------------------------


const StudentActivity = () => {
    const params = useParams();
    const location = useLocation();

    const {studentUsername} = location.state || {};

    // Component
    return (
        <Box marginTop="24px">
            <Typography variant="h6" sx={{textAlign: 'center', marginBottom: 2}}>Activities for {studentUsername}</Typography>

            <TableContainer component={Paper} elevation={4} sx={{maxHeight: '60vh', margin: 'auto', width: '80%'}}>
                <StudentActivityTable studentID={params.studentId} />
            </TableContainer>
        </Box>
    )
};



// --------------------------------------------------
//   Export(s)
// --------------------------------------------------

export default StudentActivity;
